import React, {FunctionComponent} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {IState} from '../../../store/reducers';
import {toggleTriggerDialog} from '../../../store/actions/uiActions';
import TriggerDialog from './TriggerDialog';
import {TRIGGER_SOURCE} from './constants';

interface TriggerDialogContainerProps {
  source?: TRIGGER_SOURCE;
  triggerProps?: {
    showTriggerType?: boolean;
    showDelete?: boolean;
  }
}

const TriggerDialogContainer: FunctionComponent<TriggerDialogContainerProps> = ({
  source = TRIGGER_SOURCE.REPORT,
  triggerProps
}: TriggerDialogContainerProps) => {
  /*
   * Only used to handle TriggerDialog's visibility.
   */
  const showTriggerDialog = useSelector((state: IState) => state.ui.showTriggerDialog);
  const triggerDialogType = useSelector((state: IState) => state.ui.triggerDialogType);
  const triggerDialogData = useSelector((state: IState) => state.ui.triggerDialogData);
  const dispatch = useDispatch();

  const onCloseTriggerDialog = () => {
    dispatch(toggleTriggerDialog(false));
  }

  return (
    showTriggerDialog && (
      <TriggerDialog
        show={showTriggerDialog}
        source={source}
        onClose={onCloseTriggerDialog}
        data={triggerDialogData}
        type={triggerDialogType}
        showTriggerType={triggerProps?.showTriggerType}
        showDelete={triggerProps?.showDelete}
      />
    ) || null
  );
};

export default TriggerDialogContainer;
